import { types } from 'mobx-state-tree';

const ShippingSelectionFieldType = {
  TEXT: 'TEXT',
  SELECT: 'SELECT',
  BOOLEAN: 'BOOLEAN',
};

export default ShippingSelectionFieldType;

export const ShippingSelectionFieldTypeType = types.enumeration(
  'ShippingSelectionFieldTypeType',
  Object.values(ShippingSelectionFieldType)
);
